import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import ReactPlayer from "react-player";
import Spinner from "components/Loader/Spinner";

export default function QuestionExplanationVideo({
	isOpen, toggle, videoUrl
}) {
	  const [loading, setLoading] = useState(true);
	return (
		<Modal
			show={isOpen}
			centered
			className="text-translate-modal videopopup"
			size="lg"
		>
			<Modal.Header
				className="text-translation"
				tag="div"
			>
				<Modal.Title className="text-translation popup_heading m-0">
				Explanation Video
				</Modal.Title>
				<Button variant="link" className="modalClose-Btn p-0" onClick={toggle}>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 24 24"
						width="24"
						height="24"
					>
						<path
							d="M18 6L6 18M6 6l12 12"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				</Button>
			</Modal.Header>
			<Modal.Body>
			<div className="video-container">
				{loading && (
				<div className="video-loader">
					<Spinner
					id="mocklist-spinner-tag-video"
					className="spinner-border"
					/>
				</div>
				)}

				<ReactPlayer
					url={videoUrl}
					controls
					width="100%"
					height="100%"
					onReady={() => setLoading(false)}
					onBufferEnd={() => setLoading(false)}
				/>
			</div>
			</Modal.Body>
		</Modal>
	);
}